import React from 'react'
import { Link } from 'react-router-dom'
import Bgimg from '../../assets/images/resources/service-sidebar-d-1.png'
import Serviceimg1 from '../../assets/images/resources/service-d-1.png'
import Servicedtlsimg from '../../assets/images/resources/service-details-p-1.png'

function DigitalMarketing() {
    return (
        <>
            <section className="service-details">
                <div className="container">
                    <div className="row gutter-y-30">

                        <div className="col-md-12 col-lg-4">
                            <div className="service-sidebar">
                                <div className="service-sidebar__single">
                                    <ul className="list-unstyled service-sidebar__nav">
                                        <ul>
                                            <li>
                                                <Link to="/it-recruitment">IT Recruitment</Link>
                                            </li>
                                            <li>
                                                <Link to="/non-it-recruitment">Non-IT Recruitment</Link>
                                            </li>
                                            <li>
                                                <Link to="/digital-marketing">Digital Marketing</Link>
                                            </li>
                                            <li>
                                                <Link to="/executive-search">Executive Search</Link>
                                            </li>
                                            <li>
                                                <Link to="/campus-hiring">Campus Hiring</Link>
                                            </li>
                                            <li>
                                                <Link to="/internship-training">Internship & Training Programs</Link>
                                            </li>
                                            <li>
                                                {" "}
                                                <Link to="/hr-consulting">HR Consulting</Link>
                                            </li>
                                            <li>
                                                <Link to="/career-guidance">Career Guidance & Placement Assistance</Link>
                                            </li>
                                            <li>
                                                <Link to="/digital-hiringsolutions">Digital HiringSolutions</Link>
                                            </li>
                                        </ul>
                                    </ul>
                                </div>
                                <div className="service-sidebar__single ">
                                    <div className="service-sidebar__contact background-base" style={{ backgroundImage: `url(${Bgimg})` }}>
                                        <h3 className="service-sidebar__contact__title">
                                           Digital Marketing Training
                                        </h3>
                                        <Link className="hiredots-btn" to="/contact">
                                            {" "}
                                            Contact
                                        </Link>
                                    </div>
                                </div>
                                {/* <div className="service-sidebar__single ">
                                    <div className="service-sidebar__download background-primary">
                                        <div className="service-sidebar__download__icon">
                                            <i className="icon-pdf-file" />
                                        </div>
                                        <div className="serice-sidebar__download">
                                            <h3 className="service-sidebar__download__title">
                                                <Link to="#">Project Agreement Form</Link>
                                            </h3>
                                            <p className="service-sidebar__download__number">3.9KB</p>
                                        </div>
                                    </div>
                                </div> */}
                            </div>
                        </div>
                        <div className="col-md-12 col-lg-8">
                            <div className="service-details__content">
                                <div className="service-details__thumbnail">
                                    <img src={Serviceimg1} alt="Staffing Solution" />
                                </div>
                                <h3 className="service-details__title">Digital Marketing Training</h3>
                                <p className="service-details__text">
                                    We offer comprehensive digital marketing training programs designed to equip professionals with the skills and knowledge needed to excel in the ever-evolving digital landscape. Our courses cover topics such as social media marketing, search engine optimization, content strategy, and data analytics.
                                </p>
                                <h3 className="service-details__lighlight">
                                    How Do We Provide the Service?
                                </h3>
                                <p className="service-details__text">
                                    Our training programs are delivered through a combination of interactive workshops, hands-on projects, and real-world case studies. Participants will gain practical experience in creating and executing digital marketing campaigns, analyzing performance metrics, and optimizing strategies for maximum impact. Our expert instructors provide personalized guidance and mentorship to ensure that each participant achieves their learning objectives.
                                </p>
                                <h3 className="service-details__title">Why Should You Choose Us?</h3>
                                <div className="list-unstyled service-details__process">
                                    <div className="row">
                                        <div className="col-md-4">
                                            <div className="service-details__process__top item-1">
                                                <h4 className="service-details__process__title">
                                                    Industry expertise
                                                </h4>
                                                <span className="service-details__process__icon">
                                                    <i className="icon-individual" />
                                                </span>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="service-details__process__top item-2">
                                                <h4 className="service-details__process__title">
                                                    Tailored hiring

                                                </h4>
                                                <span className="service-details__process__icon">
                                                    <i className="icon-time-check" />
                                                </span>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="service-details__process__top item-3">
                                                <h4 className="service-details__process__title">
                                                    Talent network
                                                </h4>
                                                <span className="service-details__process__icon">
                                                    <i className="icon-report-card" />
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row gutter-y-30 align-items-center">
                                    <div className="col-md-6">
                                        <div className="service-details__image__circle">
                                            <img src={Servicedtlsimg} alt="" />
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <h4 className="service-details_list-title">Benefits</h4>

                                        <ul className="list-unstyled service-details__list">
                                            <li>
                                                <i className="fas fa-check-circle" /> Access to qualified and experienced professionals
                                                {" "}
                                            </li>
                                            <li>
                                                <i className="fas fa-check-circle" /> Faster recruitment process
                                            </li>
                                            <li>
                                                <i className="fas fa-check-circle" /> Improved workforce performance
                                            </li>
                                            <li>
                                                <i className="fas fa-check-circle" /> Reduced employee turnover
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default DigitalMarketing